if (typeof window.debounce === 'undefined') {
  window.debounce = function (fn, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  };
}

(function () {
  const giftCfg = window.aeGiftConfig || {};
  const FREE_SHIPPING_THRESHOLD = Number(giftCfg.thresholdCents) || 3500;
  const GIFT_VARIANT_IDS = new Set(
    [giftCfg.recipeEbookVariantId, giftCfg.shilajitEbookVariantId, giftCfg.ubeEbookVariantId, giftCfg.ebook4VariantId, giftCfg.ebook5VariantId]
      .map((id) => String(id || ''))
      .filter(Boolean)
  );
  const isGiftItem = (item) => GIFT_VARIANT_IDS.has(String(item?.variant_id ?? ''));

  const money = (cents) => {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat);
    }
    return `£${(Number(cents || 0) / 100).toFixed(2)}`;
  };

  const escapeHtml = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const getDrawer = () => document.getElementById('site-cart-sidebar');
  const getSubtotalTemplate = () => document.getElementById('AncientCartSubtotalTemplate');

  if (typeof window.ancientAddToCart !== 'function') {
    window.ancientAddToCart = async function (variantId, options = {}) {
      if (!variantId) return null;

      const quantity = Number(options.quantity || 1);
      const button = options.button || null;
      const openDrawer = options.openDrawer !== false;
      const labelEl = button ? button.querySelector('.ae-product-hero__btn-text, [data-btn-text]') : null;
      const labelTarget = labelEl || button;
      const originalText = labelTarget ? labelTarget.textContent : '';

      if (button) {
        button.disabled = true;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        if (labelTarget) labelTarget.textContent = options.loadingText || 'Adding…';
      }

      try {
        // A free (£0) item may only ever be in the cart once — repeated taps on
        // e.g. the Free Sample button reopen the drawer instead of stacking qty.
        try {
          const currentCart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })).json();
          const existingLine = (currentCart.items || []).find((i) => i.variant_id === Number(variantId));
          if (existingLine && (existingLine.final_price === 0 || existingLine.price === 0)) {
            const openedDrawer = getDrawer();
            if (openDrawer && openedDrawer && typeof openedDrawer.show === 'function') openedDrawer.show();
            return currentCart;
          }
        } catch (guardErr) { /* cart check failed; proceed with normal add */ }

        const payload = { id: Number(variantId), quantity };
        if (options.sellingPlan) {
          payload.selling_plan = Number(options.sellingPlan);
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error(`Add to cart failed with ${response.status}`);
        }

        const addedItem = await response.json().catch(() => null);
        const cart = typeof window.refreshCart === 'function' ? await window.refreshCart() : null;
        const drawer = getDrawer();

        const eventDetail = { item: addedItem, cart };
        ['product_added_to_cart', 'cart:item-added', 'cart:added'].forEach((name) => {
          document.dispatchEvent(new CustomEvent(name, { detail: eventDetail }));
        });
        if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
          try { window.Shopify.onItemAdded(addedItem); } catch (err) { /* ignore */ }
        }

        if (openDrawer && drawer && typeof drawer.show === 'function') {
          drawer.show();
        }

        return cart;
      } catch (error) {
        console.error('Add to cart failed', error);
        return null;
      } finally {
        if (button) {
          button.disabled = false;
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          if (labelTarget) labelTarget.textContent = originalText;
        }
      }
    };
  }

  if (typeof window.bindAncientAddToCartButtons !== 'function') {
    window.bindAncientAddToCartButtons = function (scope = document) {
      scope.querySelectorAll('[data-ae-add-to-cart]').forEach((button) => {
        if (button.dataset.aeBound === 'true' || button.disabled) return;

        button.dataset.aeBound = 'true';
        button.addEventListener('click', () => {
          const opts = { button };
          const plan = button.getAttribute('data-default-selling-plan');
          if (plan) opts.sellingPlan = plan;
          const qty = parseInt(button.getAttribute('data-quantity'), 10);
          if (qty > 1) opts.quantity = qty;
          window.ancientAddToCart(button.getAttribute('data-variant-id'), opts);
        });
      });
    };
  }

  if (typeof window.refreshCart !== 'function') {
    window.refreshCart = async () => {
      try {
        const response = await fetch('?section_id=ae-cart-helper', {
          headers: { Accept: 'text/html' },
          credentials: 'same-origin'
        });
        if (!response.ok) throw new Error('section_id helper HTTP ' + response.status);
        const text = await response.text();
        const parsed = new DOMParser().parseFromString(text, 'text/html');

        const newCartForm = parsed.querySelector('#AjaxCartForm');
        const newSubtotal = parsed.querySelector('#AjaxCartSubtotal');
        const liveCartForm = document.getElementById('AjaxCartForm');
        const liveSubtotal = document.getElementById('AjaxCartSubtotal');
        const drawer = getDrawer();

        if (!newCartForm || !liveCartForm || !liveSubtotal) {
          throw new Error('helper section missing required nodes');
        }

        liveCartForm.innerHTML = newCartForm.innerHTML;
        if (typeof liveCartForm.ajaxifyCartItems === 'function') {
          liveCartForm.ajaxifyCartItems();
        }

        if (newSubtotal) {
          liveSubtotal.innerHTML = newSubtotal.innerHTML;
        }

        var bagCountEl = document.querySelector('[data-ae-bag-count]');
        var newCount = parsed.querySelector('[data-cart-count]');
        if (bagCountEl && newCount) bagCountEl.textContent = '(' + newCount.textContent.trim() + ')';
        var newShipping = parsed.querySelector('[data-ae-shipping-slot]');
        var liveShipping = document.querySelector('[data-ae-shipping-slot]');
        if (newShipping && liveShipping) {
          liveShipping.innerHTML = newShipping.innerHTML;
        }

        const countNode = newCartForm.querySelector('[data-cart-count]') || parsed.querySelector('[data-cart-count]');
        const totalNode = newCartForm.querySelector('[data-cart-total]') || parsed.querySelector('[data-cart-total]');
        const itemCount = countNode ? parseInt(countNode.textContent, 10) || 0 : 0;
        const totalText = totalNode ? totalNode.textContent.trim() : '';

        document.querySelectorAll('[data-header-cart-count]').forEach((el) => {
          el.textContent = itemCount;
          el.classList.toggle('visually-hidden', itemCount === 0);
          const trigger = el.closest('a, button');
          if (trigger) {
            const itemWord = itemCount === 1 ? 'item' : 'items';
            trigger.setAttribute('aria-label', `Cart, ${itemCount} ${itemWord}`);
          }
        });
        document.querySelectorAll('[data-header-cart-total]').forEach((el) => {
          if (totalText) el.textContent = totalText;
        });

        if (drawer) {
          drawer.classList.toggle('cart-is-empty', itemCount === 0);
        }

        if (typeof window.bindAncientAddToCartButtons === 'function' && drawer) {
          window.bindAncientAddToCartButtons(drawer);
        }

        document.dispatchEvent(new Event('cart-updated'));

        const recs = document.querySelector('cart-recommendations');
        if (recs && typeof recs.generateRecommendations === 'function') {
          recs.innerHTML = '';
          recs.generateRecommendations();
        }

        try {
          const cartJson = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
          return cartJson;
        } catch (e) {
          return { item_count: itemCount };
        }
      } catch (err) {
        console.warn('refreshCart (section-rendering) failed, falling back to JSON render', err);
        try {
          const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('cart.js HTTP ' + response.status);
          const cart = await response.json();
          if (cart && Array.isArray(cart.items) && typeof window.renderAncientCart === 'function') {
            window.renderAncientCart(cart);
          }
          document.dispatchEvent(new Event('cart-updated'));
          return cart;
        } catch (fallbackErr) {
          console.error('refreshCart fallback failed', fallbackErr);
          return null;
        }
      }
    };
  }

  if (typeof window.renderAncientCart !== 'function') {
    window.renderAncientCart = function (cart) {
      const cartForm = document.getElementById('AjaxCartForm');
      const subtotal = document.getElementById('AjaxCartSubtotal');
      const countEls = document.querySelectorAll('[data-header-cart-count]');
      const totalEls = document.querySelectorAll('[data-header-cart-total]');
      const drawer = getDrawer();
      const shippingMessage = document.querySelector('[data-cart-shipping-message]');
      const shippingFill = document.querySelector('[data-cart-shipping-fill]');
      const shippingIcon = document.querySelector('[data-cart-shipping-icon]');

      if (!cartForm || !subtotal || !drawer) return;

      drawer.classList.toggle('cart-is-empty', !cart.item_count);

      const itemsHtml = cart.items.length
        ? cart.items.map((item) => {
          const giftFlag = isGiftItem(item);
          const badgeHtml = giftFlag
            ? '<span class="cart-item__free-gift-badge">🎁 Free Gift</span>'
            : '';
          const priceHtml = giftFlag
            ? '<strong class="cart-item__price cart-item__price--free">FREE</strong>'
            : `<span class="cart-item__price">${money(item.final_line_price)}</span>`;
          const qtyControlsHtml = giftFlag
            ? '<span class="cart-item__gift-qty" aria-label="Free gift quantity">Qty 1</span>'
            : `<cart-product-quantity>
                    <button type="button" class="qty-button qty-minus" aria-label="Decrease quantity">−</button>
                    <input class="qty qty-selector" value="${Number(item.quantity || 0)}" min="0" inputmode="numeric" aria-label="Quantity" disabled>
                    <button type="button" class="qty-button qty-plus" aria-label="Increase quantity">+</button>
                  </cart-product-quantity>
                  <a href="#" class="remove">Remove</a>`;
          return `
          <div class="cart-item${giftFlag ? ' cart-item--free-gift' : ''}" data-js-cart-item data-id="${escapeHtml(item.key)}">
            <a class="cart-item__thumbnail" href="${escapeHtml(item.url)}">
              ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '<span class="cart-item__thumbnail-placeholder"></span>'}
            </a>
            <div class="cart-item__content">
              <div>
                ${badgeHtml}
                <a class="cart-item__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
                ${priceHtml}
                <div class="cart-item__actions">
                  ${qtyControlsHtml}
                </div>
              </div>
            </div>
          </div>
        `;
        }).join('')
        : '<div class="cart--empty">Your cart is empty</div>';

      cartForm.innerHTML = `<form class="cart__form">${itemsHtml}</form>`;
      if (typeof cartForm.ajaxifyCartItems === 'function') {
        cartForm.ajaxifyCartItems();
      }

      if (cart.item_count) {
        const subtotalTemplate = getSubtotalTemplate();
        if (subtotalTemplate) {
          subtotal.innerHTML = subtotalTemplate.innerHTML;
          const subtotalValue = subtotal.querySelector('[data-cart-subtotal-value]');
          if (subtotalValue) subtotalValue.textContent = money(cart.total_price);
        } else {
          subtotal.innerHTML = `<div class="ancient-cart-checkout-area"><div class="ancient-cart-subtotal-row"><span>Subtotal</span><strong>${money(cart.total_price)}</strong></div><div class="ancient-cart-tax-note">Taxes and shipping calculated at checkout</div><a class="cart-continue" href="/checkout">Checkout</a></div>`;
        }
      } else {
        subtotal.innerHTML = '';
      }

      const progress = Math.max(0, Math.min(100, (cart.total_price / FREE_SHIPPING_THRESHOLD) * 100));
      const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - cart.total_price);

      if (shippingMessage) {
        shippingMessage.innerHTML = remaining > 0
          ? `Spend <strong>${money(remaining)}</strong> more, get Free UK Shipping!`
          : 'You\'ve unlocked Free UK Shipping!';
      }

      if (shippingFill) shippingFill.style.width = `${progress}%`;
      if (shippingIcon) shippingIcon.style.left = `${progress}%`;

      countEls.forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.toggle('visually-hidden', cart.item_count === 0);
        const trigger = el.closest('a, button');
        if (trigger) {
          const itemWord = cart.item_count === 1 ? 'item' : 'items';
          trigger.setAttribute('aria-label', `Cart, ${cart.item_count} ${itemWord}`);
        }
      });
      totalEls.forEach((el) => { el.textContent = money(cart.total_price); });
      window.bindAncientAddToCartButtons(drawer);
    };
  }

  if (typeof window.SidebarDrawer !== 'function') {
    class SidebarDrawer extends HTMLElement {
      constructor() {
        super();
        this.closeButton = this.querySelector('[data-js-close]');
        this.handleEscape = this.handleEscape.bind(this);
        this.handleFocusTrap = this.handleFocusTrap.bind(this);
      }

      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.closeButton?.addEventListener('click', () => this.hide());
        document.addEventListener('keydown', this.handleEscape);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.handleEscape);
        document.removeEventListener('keydown', this.handleFocusTrap);
      }

      handleEscape(event) {
        if (event.key === 'Escape' && this.classList.contains('sidebar--opened')) {
          this.hide();
        }
      }

      getFocusable() {
        return Array.from(this.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((el) => el.offsetParent !== null || el === document.activeElement);
      }

      handleFocusTrap(event) {
        if (event.key !== 'Tab') return;
        if (!this.classList.contains('sidebar--opened')) return;

        const focusable = this.getFocusable();
        if (focusable.length === 0) {
          event.preventDefault();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus({ preventScroll: true });
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus({ preventScroll: true });
        }
      }

      show() {
        this.lastFocused = document.activeElement;
        this.removeAttribute('aria-hidden');
        document.body.classList.add('sidebar-opened');
        this.style.display = 'grid';
        document.addEventListener('keydown', this.handleFocusTrap);
        requestAnimationFrame(() => {
          this.classList.add('sidebar--opened');
          if (this.closeButton) {
            this.closeButton.focus({ preventScroll: true });
          }
        });
      }

      hide() {
        this.classList.remove('sidebar--opened');
        document.body.classList.remove('sidebar-opened');
        document.removeEventListener('keydown', this.handleFocusTrap);
        window.setTimeout(() => {
          if (!this.classList.contains('sidebar--opened')) {
            this.setAttribute('aria-hidden', 'true');
            this.style.display = 'none';
          }
        }, 320);
        if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
          this.lastFocused.focus({ preventScroll: true });
        }
      }
    }

    window.SidebarDrawer = SidebarDrawer;
    customElements.define('sidebar-drawer', SidebarDrawer);
  }

  if (typeof window.CartForm !== 'function') {
    class CartForm extends HTMLElement {
      constructor() {
        super();
        this.ajaxifyCartItems = this.ajaxifyCartItems.bind(this);
        this.updateCartQty = this.updateCartQty.bind(this);
      }

      connectedCallback() {
        this.ajaxifyCartItems();
      }

      ajaxifyCartItems() {
        this.form = this.querySelector('form');

        this.querySelectorAll('[data-js-cart-item]').forEach((item) => {
          const remove = item.querySelector('.remove');
          const qty = item.querySelector('.qty');

          if (remove && !remove.dataset.bound) {
            remove.dataset.bound = 'true';
            remove.addEventListener('click', (event) => {
              event.preventDefault();
              this.updateCartQty(item, 0);
            });
          }

          if (qty && !qty.dataset.bound) {
            qty.dataset.bound = 'true';
            qty.addEventListener('change', debounce((event) => {
              event.preventDefault();
              event.target.blur();
              if (!this._updating) {
                this.updateCartQty(item, parseInt(qty.value, 10));
              }
            }, 350));
          }
        });
      }

      updateCartQty(item, newQty) {
        if (this._updating) return;

        this._updating = true;
        this.form?.classList.add('processing');

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: item.dataset.id,
            quantity: Math.max(0, Number(newQty) || 0)
          })
        })
          .then((response) => {
            if (!response.ok) throw new Error('cart change HTTP ' + response.status);
            return response.json();
          })
          .then(() => window.refreshCart?.())
          .catch((err) => {
            console.error('cart change failed', err);
            window.refreshCart?.();
          })
          .finally(() => {
            this.form?.classList.remove('processing');
            this._updating = false;
          });
      }
    }

    window.CartForm = CartForm;
    customElements.define('cart-form', CartForm);
  }

  if (typeof window.CartProductQuantity !== 'function') {
    class CartProductQuantity extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.querySelector('.qty-minus')?.addEventListener('click', () => this.bump(-1));
        this.querySelector('.qty-plus')?.addEventListener('click', () => this.bump(1));
      }

      bump(delta) {
        if (delta > 0) return; // TEMPORARILY disabled: no quantity increases in the cart (remove this line to restore)
        const input = this.querySelector('.qty');
        if (!input) return;

        const current = parseInt(input.value, 10) || 0;
        const next = Math.max(0, current + delta);
        const item = this.closest('[data-js-cart-item]');

        if (next === 0 && item) {
          const removeBtn = item.querySelector('.remove');
          if (removeBtn) {
            removeBtn.click();
            return;
          }
        }

        input.value = next;
        const form = document.getElementById('AjaxCartForm');
        if (form && item && typeof form.updateCartQty === 'function') {
          form.updateCartQty(item, next);
        }
      }
    }

    window.CartProductQuantity = CartProductQuantity;
    customElements.define('cart-product-quantity', CartProductQuantity);
  }

  function wireCartTriggers() {
    const overlay = document.querySelector('[data-js-sidebar-overlay]');
    const drawer = getDrawer();

    document.querySelectorAll('[data-ae-open-cart]').forEach((trigger) => {
      if (trigger.dataset.aeCartBound === 'true') return;
      trigger.dataset.aeCartBound = 'true';
      trigger.addEventListener('click', (event) => {
        const d = getDrawer();
        if (!d) return;
        event.preventDefault();
        if (overlay) overlay.classList.add('is-active');
        if (typeof d.show === 'function') {
          d.show();
        }
      });
    });

    if (overlay && !overlay.dataset.aeBound) {
      overlay.dataset.aeBound = 'true';
      overlay.addEventListener('click', () => {
        const d = getDrawer();
        if (d && typeof d.hide === 'function') d.hide();
      });
    }

    if (drawer && !drawer.dataset.aeOverlaySync) {
      drawer.dataset.aeOverlaySync = 'true';
      const observer = new MutationObserver(() => {
        const isOpen = drawer.classList.contains('sidebar--opened');
        if (overlay) overlay.classList.toggle('is-active', isOpen);
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireCartTriggers);
  } else {
    wireCartTriggers();
  }
  document.addEventListener('shopify:section:load', wireCartTriggers);

  if (!window.__aeCartSubCtaDelegated) {
    window.__aeCartSubCtaDelegated = true;
    document.addEventListener('click', function (ev) {
      var confirm = ev.target.closest('[data-ae-sub-confirm]');
      if (confirm) {
        ev.preventDefault();
        if (confirm.disabled) return;
        var lineKey = confirm.dataset.lineKey;
        var popup = confirm.closest('[data-ae-sub-picker]');
        var select = popup && popup.querySelector('[data-ae-sub-freq-select]');
        var planId = select ? parseInt(select.value, 10) : 0;
        if (!lineKey || !planId) return;

        var originalLabel = confirm.innerHTML;
        confirm.disabled = true;
        confirm.innerHTML = '<span>Updating…</span>';

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
          body: JSON.stringify({ id: lineKey, selling_plan: planId })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('subscribe swap HTTP ' + res.status);
            return res.json();
          })
          .then(function () {
            if (typeof window.refreshCart === 'function') window.refreshCart();
          })
          .catch(function (err) {
            console.error('[ae sub swap] failed', err);
            confirm.disabled = false;
            confirm.innerHTML = originalLabel;
            if (typeof window.refreshCart === 'function') window.refreshCart();
          });
        return;
      }

      var toggle = ev.target.closest('[data-ae-sub-toggle]');
      if (toggle) {
        ev.preventDefault();
        var cta = toggle.closest('[data-ae-sub-cta]');
        var picker = cta && cta.querySelector('[data-ae-sub-picker]');
        if (!picker) return;
        var willOpen = picker.hasAttribute('hidden');
        document.querySelectorAll('[data-ae-sub-picker]:not([hidden])').forEach(function (p) {
          if (p !== picker) {
            p.setAttribute('hidden', '');
            var t = p.closest('[data-ae-sub-cta]')?.querySelector('[data-ae-sub-toggle]');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
        picker.toggleAttribute('hidden', !willOpen);
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }

      if (!ev.target.closest('[data-ae-sub-picker]')) {
        document.querySelectorAll('[data-ae-sub-picker]:not([hidden])').forEach(function (p) {
          p.setAttribute('hidden', '');
          var t = p.closest('[data-ae-sub-cta]')?.querySelector('[data-ae-sub-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  if (!window.__aeRecAddDelegated) {
    window.__aeRecAddDelegated = true;
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest && ev.target.closest('.ancient-drawer-rec-card__add[data-ae-add-to-cart]');
      if (!btn || btn.disabled) return;
      if (btn.dataset.aeBound === 'true') return;
      ev.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId || typeof window.ancientAddToCart !== 'function') return;
      var opts = { button: btn };
      var plan = btn.getAttribute('data-default-selling-plan');
      if (plan) opts.sellingPlan = plan;
      window.ancientAddToCart(variantId, opts);
    });
  }

  // Google ad offer price (saved by the product page when the Google automated
  // discount renders): mirror it on matching one-time lines in the drawer and
  // adjust the displayed subtotal. The real deduction happens at checkout.
  (function () {
    var busy = false;
    function fmtMoney(cents) { return '£' + (cents / 100).toFixed(2); }
    async function applyGoogleOffer() {
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem('aeGoogleDisc') || 'null'); } catch (e) {}
      if (!saved || !saved.id || !(saved.cents > 0) || busy) return;
      busy = true;
      try {
        var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        var off = 0;
        cart.items.forEach(function (item) {
          if (item.variant_id !== saved.id || item.selling_plan_allocation || saved.cents >= item.final_price) return;
          off += (item.final_price - saved.cents) * item.quantity;
          var row = document.querySelector('[data-js-cart-item][data-id="' + item.key + '"]');
          var priceEl = row && row.querySelector('.cart-item__price');
          if (!priceEl || priceEl.dataset.gdisc === '1') return;
          priceEl.dataset.gdisc = '1';
          priceEl.innerHTML = '<s style="opacity:.55;font-weight:400;margin-right:6px">' + fmtMoney(item.final_line_price) + '</s><strong>' + fmtMoney(saved.cents * item.quantity) + '</strong>';
        });
        if (off > 0) {
          var subHolder = document.getElementById('AjaxCartSubtotal');
          var subVal = subHolder && (subHolder.querySelector('[data-cart-subtotal-value]') || subHolder.querySelector('.ancient-cart-subtotal-row strong'));
          if (subVal && subVal.dataset.gdisc !== '1') {
            subVal.dataset.gdisc = '1';
            subVal.textContent = fmtMoney(cart.total_price - off);
            var rowEl = subVal.closest('div');
            if (rowEl && !subHolder.querySelector('[data-gdisc-note]')) {
              rowEl.insertAdjacentHTML('afterend', '<div class="ancient-cart-tax-note" data-gdisc-note>Your offer price is applied at checkout</div>');
            }
          }
        }
      } catch (e) {} finally { busy = false; }
    }
    document.addEventListener('cart-updated', function () { setTimeout(applyGoogleOffer, 50); });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(applyGoogleOffer, 800); });
    } else {
      setTimeout(applyGoogleOffer, 800);
    }
  })();

  // Open the cart drawer automatically when the URL asks for it, e.g. links
  // from abandoned cart emails: any page URL with ?cart=open or #cart.
  (function () {
    var wantsCart = /[?&]cart=open(&|$)/.test(window.location.search) || window.location.hash === '#cart';
    if (!wantsCart) return;
    var tries = 0;
    var attempt = function () {
      var d = document.getElementById('site-cart-sidebar');
      if (d && typeof d.show === 'function') { d.show(); return; }
      if (++tries < 40) setTimeout(attempt, 150);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(attempt, 300); });
    } else {
      setTimeout(attempt, 300);
    }
  })();
})();
